import type { AxiosResponse } from 'axios';

import i18n from '../plugins/i18n/i18n';

const errorMessageAdapter = (error: any): string => {
  // Trata erro de rate limit customizado (após 3 tentativas)
  if (error.isRateLimitError) {
    return i18n.t('errors.rateLimitExceeded', {
      defaultValue: 'Too many requests at the moment. Please wait a few seconds and try again. If the problem persists, reload the page.'
    });
  }

  const response: AxiosResponse | undefined = error.response || {};

  if (response?.data?.message) return response?.data?.message;

  if (typeof response?.data?.error === 'string') return response?.data?.error;

  if (typeof response?.data?.errors === 'string') return response?.data?.errors;

  if (typeof response?.data?.response === 'string') return response?.data?.response;

  if (typeof response?.data?.data?.response === 'string') return response?.data?.data?.response;

  return 'Unknown error';
};

// Helper para verificar se é erro de rate limit e permitir retry manual
export const isRateLimitError = (error: any): boolean => {
  return error?.isRateLimitError === true || error?.response?.status === 429;
};

// Helper para fazer retry manual de uma requisição que falhou por rate limit
export const retryRateLimitedRequest = async (error: any): Promise<any> => {
  if (error?.isRateLimitError && typeof error?.retry === 'function') {
    return error.retry();
  }
  throw new Error('Cannot retry: error is not a rate limit error or retry function not available');
};

export { errorMessageAdapter };
